import React, { Component } from 'react';
import { connect } from 'react-redux';
import Table from '../../../components/UI/Table/Table';
import Blank from '../../../hoc/Blank/Blank';
import Spinner from '../../../components/UI/Spinner/Spinner';
import * as actions from '../../../store/actions/index';
import ScoutsWithApprovalsSelector from '../../../components/Order/ScoutSelector/ScoutsWithApprovalsSelector'



class AdminCallList extends Component {
  componentDidMount() {
    this.props.onLoadResult('updated', false);
    this.props.onFetchOrders();
    this.props.onInit();

    this.props.onGetScouts();
  }

  state = {
    showEditOrder: false,
    showSuccess: false,
    orderId: 0,
    width: window.innerWidth,
    callListOrder: null,
    purchased: false,
    searched: false,
    userId: 0
  }

  cancelEditOrderHandler = () => {
    this.setState({ showEditOrder: false, showSuccess: false, purchased: false, orderId: 0, callListOrder: null, purchase: false });
  }

  successPopupHandler = () => {
    this.setState({ showEditOrder: false, purchased: true, showSuccess: true, orderId: 0, callListOrder: null });
  }

  scoutChanged = (value) => {
    this.setState({ userId: value });
  }

  approveOrder = (event, orderId) => {
    this.props.onApprove(orderId);
  }
  showOrder = (e) => {
    let oid = e.currentTarget.getAttribute('oid');

    for (let key in this.props.orders) {
      if (this.props.orders[key].orderId === oid) {
        this.setState({ callListOrder: this.props.orders[key], orderId: oid }, () => {
          this.setState({ showEditOrder: true });
        }
        );
        //,orderId : e.currentTarget.getAttribute('oid'), showEditOrder:true});
        break;
      }
    }
  }

  formatCurrency(value) {
    if (!value || value == '') {
      return '$0.00';
    }
    else {
      return '$' + parseFloat(value).toFixed(2);
    }
  }

  render() {

    if (this.props.orders && this.props.orders.length && this.state.userId > 0) {

      var data = [];
      let pl = "15px";
      let fifty = "50px";
      let oneHundred = "100px";
      let oneFifty = "150px";
      let seventyFive = "75px";

      if (window.innerWidth < 500) {
        pl = "5px";
        fifty = "40px";
        oneHundred = "75px";
        oneFifty = "100px";
        seventyFive = "50px";
      }

      const ords = [];

      for (let k in this.props.orders) {
        if (this.props.orders[k].status == 'initial' &&
          this.props.orders[k].paymentStatus == 'paid' &&
          this.props.orders[k].userId == this.state.userId) {
          ords.push(this.props.orders[k]);
        }
      }
      let i = -1;
      for (let k1 in ords) {
        let order = ords[k1]
        i = i + 1;
        data.push({
          oid: order.orderId, data: [
            {
              oid: (order.orderId),
              type: 'button',
              label: 'Approve',
              style: { width: fifty, paddingleft: pl, textAlign: 'right' },
              full: true
            },
          {
            value: order.orderId,
            style: { paddingLeft: pl, width: seventyFive },
            full: false,
            format: ''
          },
          {
            value: order.name,
            style: { width: oneHundred, paddingLeft: pl },
            full: false,
            format: ''
          }]
        });

        if (this.props.mulchYear.sellHardwood) {
          data[i].data.push({
            value: order.hardwoodBags,
            style: { width: fifty, paddingLeft: pl, textAlign: 'right' },
            full: false,
            format: ''
          })
        }

        if (this.props.mulchYear.sellCedar) {
          data[i].data.push(
            {
              value: order.cedarBags,
              style: { width: fifty, paddingLeft: pl, textAlign: 'right' },
              full: false,
              format: ''
            })
        }

        if (this.props.mulchYear.sellBlack) {
          data[i].data.push(
            {
              value: order.blackBags,
              style: { width: fifty, paddingLeft: pl, textAlign: 'right' },
              full: false,
              format: ''
            })
        }

        if (this.props.mulchYear.sellRed) {
          data[i].data.push(
            {
              value: order.redBags,
              style: { width: fifty, paddingLeft: pl, textAlign: 'right' },
              full: false,
              format: ''
            })
        }

        data[i].data.push(
          {
            value: this.formatCurrency(order.total),
            style: { width: fifty, paddingLeft: pl, textAlign: 'right' },
            full: false,
            format: 'currency'
          },
          {
            value: (this.formatCurrency(parseFloat(order.checkAmount) + parseFloat(order.cashAmount))),
            style: { width: fifty, paddingleft: pl, textAlign: 'right' },
            full: false,
            format: 'currency'
          },
          {
            value: (order.checkNumber),
            style: { width: fifty, paddingleft: pl, textAlign: 'right' },
            full: false,
            format: ''
          },
          {
            value: (this.formatCurrency(order.checkAmount)),
            style: { width: fifty, paddingleft: pl, textAlign: 'right' },
            full: false,
            format: 'currency'
          },
          {
            value: (this.formatCurrency(order.cashAmount)),
            style: { width: fifty, paddingleft: pl,paddingRight:pl, textAlign: 'right' },
            full: false
          }
          
        );
        }
        var header = [
          {
            name: "",
            style: { width: fifty, paddingLeft: pl },
            full: false
          },
        {
          name: "Order",
          style: { paddingLeft: pl, width: seventyFive }
        },
        {
          name: "Name",
          style: { width: oneHundred, paddingLeft: pl }
        }];

        if (this.props.mulchYear.sellHardwood) {
          header.push(
            {
              name: "Hwd",
              style: { width: fifty, paddingLeft: pl, textAlign: 'right' }
            })
        }
        if (this.props.mulchYear.sellCedar) {
          header.push(
            {
              name: "Cdr",
              style: { width: fifty, paddingLeft: pl, textAlign: 'right' }
            })
        }

        if (this.props.mulchYear.sellBlack) {
          header.push(
            {
              name: "Blk",
              style: { width: fifty, paddingLeft: pl, textAlign: 'right' }
            })
        }

        if (this.props.mulchYear.sellRed) {
          header.push(
            {
              name: "Red",
              style: { width: fifty, paddingLeft: pl, textAlign: 'right' }
            })
        }

        header.push(
          {
            name: "Total Due",
            style: { width: fifty, paddingLeft: pl, textAlign: 'right' },
            full: false
          },
          {
            name: "Total Paid",
            style: { width: fifty, paddingLeft: pl, textAlign: 'right' },
            full: false
          }
          ,
          {
            name: "Check #",
            style: { width: fifty, paddingLeft: pl, textAlign: 'right' },
            full: false
          },
          {
            name: "Check $",
            style: { width: fifty, paddingLeft: pl, textAlign: 'right' },
            full: false
          },
          {
            name: "Cash",
            style: { width: fifty, paddingLeft: pl,paddingRight:pl, textAlign: 'right' },
            full: false
          }          
        );

        return (

          <Blank>
            <ScoutsWithApprovalsSelector onDataChanged={this.scoutChanged} scoutUserId={this.state.userId}></ScoutsWithApprovalsSelector>
            <Table header={header} data={data} onClick={this.approveOrder}></Table>

          </Blank>
        );
      }
    else if (this.props.loading) {
        return (
          <div>
            <Spinner />
          </div>
        );
      }
      else {
        return (
          <div>
            <ScoutsWithApprovalsSelector onDataChanged={this.scoutChanged} scoutUserId={this.state.userId}></ScoutsWithApprovalsSelector>

          </div>
        );
      }
    }
  }

  const mapStateToProps = state => {
    return {
      mulchYear: state.orders.mulchYear,
      scouts: state.orders.scoutsWithApprovals,
      loading: state.orders.loading,
      orders: state.orders.orders,
      updated: state.orders.updated
    };
  };

  const mapDispatchToProps = dispatch => {
    return {
      onGetScouts: () => dispatch(actions.getScoutsForApproval()),
      onFetchOrders: () => dispatch(actions.fetchOrders()),
      onSearch: (UserId) => dispatch(actions.getOrdersForApproval(UserId)),
      onApprove: (orderId) => dispatch(actions.approveOrder(orderId)),
      onLoadResult: (token, value) => dispatch(actions.loadResult(token, value)),
      onInit: () => dispatch(actions.initSearchResults()),
    };
  };

  export default connect(mapStateToProps, mapDispatchToProps)(AdminCallList);



// WEBPACK FOOTER //
// ./src/containers/Orders/ApproveOrders/ApproveOrders.js